import { useWebChat } from "../../context";
import MinimizeIcon from "../../icons/MinimizeIcon";
import styled from '@emotion/styled'
import { SrOnly, Button } from "../../styledComponents";
import Toggle from '../Toggle';
import locales from "../../locales";
import Menu from "../Menu";
import HomeIcon from "../../icons/Home";

const ChatHeader = styled.header`
  height: var(--chat-header-height);
  background: var(--color-primary-dark);
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
`;

const ButtonMinimize = styled(Button)`
  position: absolute;
  height: 100%;
  padding-left: 1.5em;
  padding-right: 1.5em;
  top: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
`;

const ButtonHome = styled(Button)`
  background: transparent;
  border: none;
  position: absolute;
  left: 8px;
  padding: 8px;
`;

const Header = () => {
  const { handleMinimizeButtonClick, lang, openMenu } = useWebChat();

  return (
    <>
      <Menu />
      <ChatHeader>
        <ButtonHome onClick={openMenu}>
          <HomeIcon />
          <SrOnly>Open menu</SrOnly>
        </ButtonHome>
        <Toggle />
        <ButtonMinimize onClick={handleMinimizeButtonClick}>
          <MinimizeIcon />
          <SrOnly>{locales(lang, 'closeChat')}</SrOnly>
        </ButtonMinimize>
      </ChatHeader>
    </>
  )
}

export default Header;
